'use strict';
import * as tools from './tools.js';

window.$ = window.jQuery = require('jquery');
window.Popper = require('@popperjs/core');
window.bootstrap = require('bootstrap');

import lazyframe from "lazyframe";
lazyframe(".lazyframe", {
    autoplay: true,
});

import Swiper, {Navigation, Pagination} from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import {showHideDownloadHelpLanguage} from "./tools.js";

const swiper = new Swiper('.swiper__full', {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    navigation : {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: '.swiper-pagination',
    },
    on: {
        init: function () {
            let headerHeight = document.querySelector('header').offsetHeight;
            this.el.style.height = (innerHeight - headerHeight) + 'px';
            tools.pauseSliderVideos(this);
            tools.playSliderVideos(this);
        },
        transitionStart: function(){
            tools.pauseSliderVideos(this);
        },
        transitionEnd: function(){
            tools.playSliderVideos(this);
        },
    },
});


$(function () {

	var selectCustom = ['autore','klasiko','genero','fikzio','kategoria'];

	for (let s in selectCustom) {
		let defaultselectbox = $('select#' + selectCustom[s]);

		if(typeof defaultselectbox.html() !== 'undefined') {
			let numOfOptions = defaultselectbox.children('option').length;

			// hide select tag
			defaultselectbox.addClass('s-hidden');

			// wrapping default selectbox into custom select block
			defaultselectbox.wrap('<div class="cusSelBlock"></div>');

			// creating custom select div
			defaultselectbox.after('<div class="selectLabel"></div>');
			let selectLabel = defaultselectbox.parent().find('.selectLabel');

			// getting default select box selected value
			if(defaultselectbox.val() !== '') {
				selectLabel.text(defaultselectbox.children('option[value="' + defaultselectbox.val() + '"]').eq(0).text());
			} else {
				selectLabel.text(defaultselectbox.children('option').eq(0).text());
			}

			// appending options to custom un-ordered list tag
			var cusList = $('<ul/>', { 'class': 'options'} ).insertAfter(selectLabel);

			// generating custom list items
			for(var i=0; i< numOfOptions; i++) {
				$('<li/>', {
					text: defaultselectbox.children('option').eq(i).text(),
					rel: defaultselectbox.children('option').eq(i).val()
				}).appendTo(cusList);
			}

			// click event functions
			selectLabel.click(function () {
				$(this).toggleClass('active');
				if( $(this).hasClass('active') ) {
					openList(defaultselectbox,numOfOptions);
					focusItems(defaultselectbox);
				}
				else {
					closeList(defaultselectbox,numOfOptions);
				}
			});

			let options = defaultselectbox.parent().find('.options').find('li');

			options.on('keypress click', function(e) {
				e.preventDefault();
				options.siblings().removeClass();
				closeList(defaultselectbox,numOfOptions);
				selectLabel.removeClass('active');
				selectLabel.text($(this).text());
				defaultselectbox.val(defaultselectbox.find('option[data-text="' + $(this).text() + '"]').attr('value'));
				$('.selected-item p span').text(selectLabel.text());
			});
		}
	}
	
});

// open-list and close-list items functions
function openList(selectBox, numOfOptions) {
	for(var i=0; i< numOfOptions; i++) {
		selectBox.parent().find('.options').children('li').eq(i).attr('tabindex', i).css(
			'transform', 'translateY('+(i*100+100)+'%)').css(
			'transition-delay', i*30+'ms');
	}
}

function closeList(selectBox, numOfOptions) {
	for(var i=0; i< numOfOptions; i++) {
		selectBox.parent().find('.options').children('li').eq(i).css(
			'transform', 'translateY('+i*0+'px)').css('transition-delay', i*0+'ms');
	}
	selectBox.parent().find('.options').children('li').eq(1).css('transform', 'translateY('+2+'px)');
	selectBox.parent().find('.options').children('li').eq(2).css('transform', 'translateY('+4+'px)');
}

function focusItems(selectBox) {

	selectBox.parent().find('.options').on('focus', 'li', function() {
		let $this = $(this);
		$this.addClass('active').siblings().removeClass();
	}).on('keydown', 'li', function(e) {
		let $this = $(this);
		if (e.keyCode == 40) {
			$this.next().focus();
			return false;
		} else if (e.keyCode == 38) {
			$this.prev().focus();
			return false;
		}
	}).find('li').first().focus();

}

//Formulario busqueda libros por ajax y comportamientos asociados
let formBooks = document.querySelector('.formbuscador.form-ajax');
let filtersBooks = document.querySelectorAll('[data-filter="books"]');
let loadingBooks = document.querySelector('.container-books .loading-container');
let containerBooks = document.querySelector('.container-books .books');
function getListBooks() {
	loadingBooks.classList.remove('d-none');
	containerBooks.innerHTML = '';
	//console.log(new URLSearchParams(new FormData(formBooks)));
	let data = new URLSearchParams(new FormData(formBooks));
	fetch(site_url + '/get_books', {
		method: 'POST',
		body: data
	}).then(response => response.json())
	 .then((response) => {
		if(response.error) {
			containerBooks.innerHTML = `<p>${response.error}</p>`;
		}else {
			let html = '<ul class="row">';
			response.forEach((currentResponse) => {
				html += `<li class="col-12 col-sm-6 col-lg-3 mb-5 book">
							${(currentResponse.categoria) ? `<a href="${currentResponse.url_libros}/?category=${currentResponse.categoria_url}"><div class="category text-uppercase">${currentResponse.categoria}</div></a>` : ''}
							<a href="${currentResponse.url}" class="card" title="${(currentResponse.titulo_l) ? currentResponse.titulo_l : currentResponse.titulo }">
								${(currentResponse.label_imagen) ? `<div class="card-img mb-3">${currentResponse.label_imagen}</div>` : ''}
								<div class="card-txt">
									${(currentResponse.autor) ? `<h3 class="author">${currentResponse.autor}</h3>` : ''}
									<h3 class="title">${((currentResponse.titulo_l) ? `${currentResponse.titulo_l} (` : '') + currentResponse.titulo + ((currentResponse.titulo_l) ? ')' : '')}</h3>
									${(currentResponse.anio) ? `<h5 class="year">${currentResponse.anio}</h5>` : ''}
								</div>
							</a>
						</li>`;
			})
			html += '</ul>';
			containerBooks.innerHTML = html;
		}
		 loadingBooks.classList.add('d-none');
	 });

}
if(typeof formBooks !== "undefined" && formBooks !== null) {
	formBooks.addEventListener('submit', (e) => {
		e.preventDefault();
		getListBooks();
	})

	filtersBooks.forEach((currentValue, currentIndex, listObj) => {
		filtersBooks[currentIndex].addEventListener('click',(e) => {
			e.preventDefault();
			let thisFilter = filtersBooks[currentIndex];
			if(thisFilter.dataset.action === 'empty') { //Filtro de todos
				if(!thisFilter.classList.contains('active')) { //Si ya esta activa no tiene sentido hacer nada
					thisFilter.classList.add('active');
					document.querySelectorAll(`[data-target="${thisFilter.dataset.target}"]`).forEach((currentFilter) => {
						if(currentFilter.classList.contains('active') && currentFilter !== thisFilter) {
							currentFilter.classList.remove('active');
							document.getElementById(currentFilter.dataset.target + '_'  + currentFilter.dataset.item).checked = false;
						}
					})
				}
			} else {
				//Filtro especifico
				if(!thisFilter.classList.contains('active')) {
					document.querySelector(`[data-target="${thisFilter.dataset.target}"][data-action="empty"]`).classList.remove('active');
					thisFilter.classList.add('active');
					document.getElementById(thisFilter.dataset.target + '_'  + thisFilter.dataset.item).checked = true;
				} else {
					thisFilter.classList.remove('active');
					document.getElementById(thisFilter.dataset.target + '_'  + thisFilter.dataset.item).checked = false;
					let allUnchecked = true;
					document.querySelectorAll(`[data-target="${thisFilter.dataset.target}"]`).forEach((currentFilter) => {
						if (currentFilter.dataset.action !== 'empty') {
							if (currentFilter.classList.contains('active')) allUnchecked = false;
						}
					})
					if(allUnchecked) document.querySelector(`[data-target="${thisFilter.dataset.target}"][data-action="empty"]`).classList.add('active');
				}
			}
			getListBooks();
		})
	})
}

/**
 * Control descargas
 **/
//Validación inicial
let linkDownload = document.querySelectorAll('.link-download');
linkDownload.forEach((link) => {
	link.addEventListener('click',(e) => {
		e.preventDefault();
		let thisLink = e.target.closest('a');

		document.querySelector('[name="archivo"]').value = thisLink.dataset.file;
	})
})

//Descarga validada
let linkDoDownload = document.querySelectorAll('.do-download');
+
linkDoDownload.forEach((link) => {
	link.addEventListener('click',(e) => {
		//e.preventDefault();
		let thisLink = e.target.closest('a'),
			href = thisLink.getAttribute('href'),
			contact = thisLink.dataset.contact,
			hrefArray = href.split('/'),
			fileName = hrefArray.pop();

		let data = new URLSearchParams(`file=${href}&contact=${contact}`);
		fetch(site_url + '/save_download', {
			method: 'POST',
			body: data
		}).then(response => response.json())
			.then((response) => {
				gtag('event', 'Descarga_Sample', {
					'file_name': fileName,
				});

				return true;
			});

	})
})



//Alturas listados libros
let bookItems = document.querySelectorAll('li.book .card-img');
let bookItemsTxt = document.querySelectorAll('li.book .card-txt');
let bookItemsCategory = document.querySelectorAll('li.book .category');
if(bookItems !== null) {
	let hBookItems = 0;
	bookItems.forEach((element) => {
		if(element.offsetHeight > hBookItems) hBookItems = element.offsetHeight;
	})
	if(hBookItems > 0) {
		bookItems.forEach((element) => {
			element.style.height = hBookItems + 'px';
		})
	}
}
if(bookItemsTxt !== null) {
	let hBookItemsTxt = 0;
	bookItemsTxt.forEach((element) => {
		if(element.offsetHeight > hBookItemsTxt) hBookItemsTxt = element.offsetHeight;
	})
	if(hBookItemsTxt > 0) {
		bookItemsTxt.forEach((element) => {
			element.style.height = hBookItemsTxt + 'px';
		})
	}
}
if(bookItemsCategory !== null) {
	let hBookItemsCategory = 0;
	bookItemsCategory.forEach((element) => {
		if(element.offsetHeight > hBookItemsCategory) hBookItemsCategory = element.offsetHeight;
	})
	if(hBookItemsCategory > 0) {
		bookItemsCategory.forEach((element) => {
			element.style.height = hBookItemsCategory + 'px';
		})
	}
}

//Menu dropdown on hover
document.addEventListener("DOMContentLoaded", () => {
	document.querySelectorAll('#main-nav-container .dropdown').forEach( (everyItem) => {
		everyItem.addEventListener('mouseover', (e) => {
			let theLink = everyItem.querySelector('a[data-bs-toggle]');
			if(theLink != null) {
				let nextEl = theLink.nextElementSibling;
				theLink.classList.add('show');
				nextEl.classList.add('show');
			}
		})
		everyItem.addEventListener('mouseleave', function(e){
			let theLink = everyItem.querySelector('a[data-bs-toggle]');

			if(theLink != null){
				let nextEl = theLink.nextElementSibling;
				theLink.classList.remove('show');
				nextEl.classList.remove('show');
			}
		})
		everyItem.addEventListener('click', function(e){
			let theLink = everyItem.querySelector('a[data-bs-toggle]');
			if(theLink != null){
				window.location.href = theLink.getAttribute('href');
			}
		})

	})
})

//Campos extras para inscripciones a newsletters
let checkAlertService = document.querySelectorAll('.check-consentimiento');
if(checkAlertService !== null) {
	checkAlertService.forEach((checkbox) => {
		checkbox.addEventListener('click',function (){
			let checkboxName = checkbox.getAttribute('name'),
				relatedFields = document.querySelectorAll(`.${checkboxName}`),
				opossed = (checkboxName === 'consentimiento') ? 'consentimiento2' : 'consentimiento';

			relatedFields.forEach((field) => {
				if(checkbox.checked) tools.showFieldDownload(field, checkboxName);
				else tools.hideFieldDownload(field, opossed);
			})

		})
	})
}